import React from "react";
import { FileText, Users, ArrowRight } from "lucide-react";
import { EmptyState, IconTile } from "@/portal/ui/Layout";
import { Button } from "@/portal/ui/Button";
import { DocumentsTable } from "@/portal/DocumentsTable";

export default function DocumentsTab({ documents, onContact, onChanged }) {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-[1fr_300px] gap-5 items-start">
      <div>
        <div className="mb-4">
          <h2 className="cp-h1 !text-[26px]">Documentele proiectului</h2>
          <p className="cp-body mt-1">Documentele publicate de echipa Brisk sunt disponibile aici.</p>
        </div>
        {documents.length === 0
          ? <EmptyState icon={FileText} title="Niciun document publicat" description="Contractele, rapoartele lunare și avizele vor apărea aici pe măsură ce sunt publicate de echipă." testid="docs-empty" />
          : <DocumentsTable documents={documents} onChanged={onChanged} />}
      </div>
      <div className="space-y-4">
        <div className="cp-panel p-5 flex items-center gap-4" data-testid="docs-count">
          <IconTile icon={FileText} size="lg" />
          <div><div className="text-[13.5px] font-semibold text-cp-text">Documente publicate</div><div className="flex items-baseline gap-2 mt-0.5"><span className="cp-metric-lg">{String(documents.length).padStart(2, "0")}</span><span className="cp-meta">în acest proiect</span></div></div>
        </div>
        <div className="cp-panel-navy p-5" data-testid="docs-help">
          <div className="flex items-start gap-3">
            <Users className="h-6 w-6 text-white/80 shrink-0 mt-0.5" aria-hidden="true" />
            <div><div className="text-[16px] font-semibold">Ai nevoie de un document?</div><p className="text-[13px] text-white/70 mt-1 leading-relaxed">Contactează managerul pentru asistență sau informații suplimentare.</p></div>
          </div>
          <Button onClick={onContact} className="w-full mt-4" data-testid="docs-contact">Contactează managerul <ArrowRight /></Button>
        </div>
      </div>
    </div>
  );
}
